require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/core-js/es6/parse-int.js
// module id = ../../../../core-js/es6/parse-int.js
// module chunks = 3